'use client'

import { smsReceipt } from '@/lib/actions/order/sms-receipt'
import { useModals, useSelectedCustomer } from '@/lib/hooks'
import { Loader2, MessageCircle } from 'lucide-react'
import React from 'react'
import { toast } from 'sonner'

import { Button, Input } from '@/components/ui'

export const SMSReceipt = ({ orderId }: { orderId: string }) => {
  const { closeModal } = useModals()
  const { customer } = useSelectedCustomer()
  const [isSending, startSending] = React.useTransition()
  const [customerPhone, setCustomerPhone] = React.useState(
    customer?.phone ?? '',
  )

  const handleSubmit = async (data: FormData) => {
    const phone = data.get('phone') as string

    if (!phone) {
      toast.error('Please enter a phone number')
      return
    }

    startSending(async () => {
      try {
        const res = await smsReceipt({ orderId, phone })

        if (res?.error) {
          toast.error(res?.error)
          return
        }

        toast.success('SMS receipt sent successfully.')
        closeModal('SMS_RECEIPT')
      } catch {
        toast.error('Failed to send SMS receipt. Please try again.')
      }
    })
  }

  return (
    <form
      className="flex w-full flex-wrap gap-4 lg:gap-8"
      action={handleSubmit}
    >
      <div className="flex w-full flex-col flex-wrap gap-4">
        <h2 className="text-balance text-xl font-medium">SMS Receipt</h2>

        <div className="flex w-full flex-col gap-5">
          <Input
            className="w-full appearance-none text-center"
            value={customerPhone}
            onChangeValue={(value) => {
              setCustomerPhone(value)
            }}
            inputSize="lg"
            name="phone"
            type="tel"
            placeholder="0777123456"
            autoFocus
          />
        </div>

        <div className="flex w-full gap-2 pt-3">
          <Button
            variant="default"
            className="w-full gap-3 shadow-card"
            size="lg"
            type="submit"
            disabled={isSending}
          >
            {isSending && <Loader2 className="size-5 animate-spin" />}
            {!isSending && (
              <MessageCircle className="size-5" strokeWidth={1.5} />
            )}
            <span>Send Receipt</span>
          </Button>
        </div>
      </div>
    </form>
  )
}
